import { render, staticRenderFns } from "./Combustible.vue?vue&type=template&id=4793e543&"
import script from "./Combustible.vue?vue&type=script&lang=js&"
export * from "./Combustible.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports